<template>
	<MainComponent v-if="page" :page="page"/>
</template>

<script lang="ts">
import MainComponent, { SchregComponents } from '@/components/MainComponent';
import { Helpers } from '@/common/helpers';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'App',
	components: {
		MainComponent
	},
	data() {
		return {
			page: ''
		};
	},
	mounted() {
		if (this.$el.parentElement) {
			const vuePage = this.$el.parentElement.getAttribute('vue-page');
			if (vuePage && SchregComponents.keyIsValid(vuePage)) {
				this.page = vuePage;
				return;
			}
		}
		if (Helpers.isDevOrUi()) {
			this.page = SchregComponents.findKeyByPath();
		}
	}
});
</script>
